import { AccordionFieldsFragment } from 'src/generated/graphql';
import { highlightBracketedText } from "src/utils/utils";
import { useEffect, useRef, useState } from 'react';
import CountUp from 'react-countup';

type NewsComponentProps = {
  content?: AccordionFieldsFragment;
};


const AnimatedNumber = ({ content }: NewsComponentProps) => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLDivElement | null>(null);
  
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(entry.isIntersecting);
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  if (!content) {
    return null;
  }

  const { title,descriptionJson, accordionItemsCollection } = content;
  const items = accordionItemsCollection?.items || [];

  const parseStatValue = (text: string) => {
    const numMatch = text.match(/^\d+/);
    const number = numMatch ? parseFloat(numMatch[0]) : 0;
    const suffix = text.slice(numMatch ? numMatch[0].length : 0);
    return { number, suffix };
  };
  const description =descriptionJson?.json?.content?.[0]?.content?.[0]?.value ?? '';


  return (
    <div className="results-section" ref={sectionRef}>
      <div className="container-fluid custom-spacer-col">
        <div className="results-inner">
          <div className="results-left">
          <span
              className="highlight-bracket-text"
              dangerouslySetInnerHTML={{
                __html: highlightBracketedText(title ?? "" , "bold"),
              }}
              style={{ textAlign: "start", fontSize: "3.5rem" ,color:"#fff" }}
            />
           
            <div className="results-description">
              <p>
                {description}
              </p>
            </div>
          </div>
          <div className="results-right">
            <div className="box-inner-count">
              {items.map((item, index) => {
                const { number, suffix } = parseStatValue(item?.itemText || "");
                return (
                  <div className="count-value text-center" key={index}>
                    <h2 className="counter">
                      {isVisible && (
                        <>
                          <CountUp end={number} duration={2} decimals={0} />
                          {suffix}
                        </>
                      )}
                    </h2>
                    <p className="">
                      <span>
                      {item?.additionalItemText}
                      </span>
                    </p>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AnimatedNumber;